import { CheckboxOrRadioLabel, RadioInput } from './field.style';
import { Text } from '@checkatrade/web-ui';
import type { RadioProps } from './field.type';

// One option MUST always be selected. So no error state.
const Radio = ({
  name,
  options,
  value,
  customContainerStyle,
  onChange,
}: RadioProps) => (
  <>
    {options.map(option => (
      <CheckboxOrRadioLabel
        as="label"
        key={option.value}
        style={customContainerStyle}
        role="container"
      >
        <div className="flex items-center gap-2">
          <RadioInput
            type="radio"
            name={name}
            value={option.value}
            checked={option.value === value}
            onChange={onChange}
          />
        </div>
        <div>
          <Text>{option.label}</Text>
          {option.subheading && (
            <Text variant={'labelMD'}>{option.subheading}</Text>
          )}
        </div>
      </CheckboxOrRadioLabel>
    ))}
  </>
);

export default Radio;
